import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { IonContent, IonIcon, IonButton, IonPage } from '@ionic/react';
import './PaymentSuccess.css';
import { checkmarkOutline } from "ionicons/icons";
import { useAppDispatch } from "../../services/redux/hook";
import { closeModal } from "../../services/redux/slices/opened_navigation_modal/opened_root_modal";


type PaymentSuccessProps = {
    successMessage?: string;
}

const PaymentSuccess: React.FC<PaymentSuccessProps> = ({successMessage}) => {
    
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    
    const close = () => {

        dispatch(closeModal());

    }


    useEffect(()=>{

        const init = async()=>{

            setTimeout(async() => {

                close()
                
            }, 2000);
        }
        init()
    },[])
    

    return (
        <IonPage>

            <IonContent className='paymentSuccessContent'>
                <div className='ion-text-center' >
                    <IonIcon className="paymentSuccessIcon" icon={checkmarkOutline} size='large' >

                    </IonIcon>
                </div>

                <div className='ion-text-center'>
                    <h2 className="paymentSuccessLabel">
                        <b>{successMessage ? successMessage : t('paymentsuccess.page.MESSAGE')}</b>
                    </h2>

                </div>

                <IonButton className="paymentSuccessCloseButton"

                    onClick={() => {close()}}
                    fill='outline'
                    expand='block'
                >
                    {t('paymentsuccess.page.BTN')}
                </IonButton>

            </IonContent>

        </IonPage>
    )

}

export default React.memo(PaymentSuccess)